import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 500;
`;

export const Input = styled.input`
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 16px;
  background: var(--surface);
  color: var(--text-primary);

  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 2px var(--primary-light);
  }
`;

export const Select = styled.select`
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 16px;
  background: var(--surface);
  color: var(--text-primary);

  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 2px var(--primary-light);
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
`;

export const Button = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  
  ${props => {
    if (props.variant === 'secondary') {
      return `
        background: var(--surface);
        color: var(--text-primary);
        border: 1px solid var(--border);
        
        &:hover {
          background: var(--hover);
        }
      `;
    }
    
    return `
      background: var(--primary);
      color: white;
      border: none;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: var(--shadow-md);
      }
    `;
  }}

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const Required = styled.span`
  color: var(--error);
  margin-left: 4px;
`;

export const ErrorMessage = styled.div`
  color: var(--error);
  font-size: 14px;
  margin-top: 4px;
`; 